import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';

import AddToCart from '../../AddToCart';
import BundleList from './BundleList';
import Benefits from '../Benefits/Benefits';

import { dataLayerPush } from '../../../utils';
import { ProductFormContext } from '../../../context/product-form-context';

const ns = `product-form`;

const BundleForm = ({ variant, product, globalSettings }) => {
	const rootClassnames = classNames({ [`${ ns }`]: true });
	const { isVariantAvailable } = React.useContext(ProductFormContext);
	const [selectedBundleItems, setSelectedBundleItems] = useState([]);
	const prevVariantTitle = useRef(null);

	const onAddToCart = () => {
		dataLayerPush().addToCart({ product, variant, quantity: 1 });
	};

	useEffect(() => {
		// Create new "view item" GA event if user selects a different variant
		if (prevVariantTitle.current !== variant.title) {
			prevVariantTitle.current = variant.title;
			dataLayerPush().viewItem({ product, variant, quantity: 1 });
		}
	}, [product, variant]);

	return (
		<div className={rootClassnames}>
			<BundleList
				product={product}
				price={variant?.price}
				compareAtPrice={variant?.compareAtPrice}
				setSelectedBundleItems={setSelectedBundleItems}
			/>
			<div className={`${ ns }__combined-button`}>
				<AddToCart
					available={isVariantAvailable()}
					variantId={variant ? variant.storefrontId : null}
					gqlProductId={product?.shopifyId || null}
					gqlVariantId={variant?.shopifyId || null}
					quantity={1}
					customAttributes={selectedBundleItems}
					handle={product.handle}
					onAddToCart={onAddToCart}
					metafields={product.metafields}
				/>
			</div>
			<div className={`${ ns }__benefits`}>
				<Benefits
					product={product}
					globalSettings={globalSettings}
				/>
			</div>
		</div>
	);
};

export default BundleForm;
